enum ActionTypes {
  EXPORT_PRICE_BOOK_REQUEST = 'PRICEBOOKS.EXPORT_PRICE_BOOK_SUBMIT',
  EXPORT_PRICE_BOOK_SUCCESS = 'PRICEBOOKS.EXPORT_PRICE_BOOK_COMPLETED',
  EXPORT_PRICE_BOOK_FAILURE = 'PRICEBOOKS.EXPORT_PRICE_BOOK_ERROR',
}

export default ActionTypes;
